import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Homepage from "./pages/Homepage";
import DeliveryCalculator from "./pages/calculators/DeliveryCalculator";
import AdminLogin from "./pages/AdminLogin";
import AdminChat from "./pages/AdminChat";
import Layout from "./pages/Layout"; // Layout wraps all public pages
import BricksCalculator from "./pages/calculators/BricksCalculator";
import WorkerFinder from "./pages/worker/WorkerFinder"; 
import BlogList from "./components/BlogList";
import BlogPage from "./components/BlogPage";
import PrivacyPolicy from "./pages/policies/PrivacyPolicy";
import RefundPolicy from "./pages/policies/RefundPolicy";
import ShippingPolicy from "./pages/policies/ShippingPolicy";
import TermsConditions from "./pages/policies/TermsConditions";
import Dhanbad from "./pages/cities/Dhanbad";
import Giridih from "./pages/cities/Giridih";
import Bokaro from "./pages/cities/Bokaro";
import Asansol from "./pages/cities/Asansol";
import Durgapur from "./pages/cities/Durgapur";
import Deoghar from "./pages/cities/Deoghar";
import Jamtara from "./pages/cities/Jamtara";


function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  return (
    <HelmetProvider>
    <Router>
      <Routes>
        {/* Public routes wrapped in Layout */}
        <Route
          path="/"
          element={
            <Layout>
              <Homepage />
            </Layout>
          }
        />
        <Route
          path="/delivery-calculator"
          element={
            <Layout>
              <DeliveryCalculator />
            </Layout>
          }
        />

        {/* Admin routes (no Layout) */}
        <Route
          path="/admin-login"
          element={<AdminLogin setIsAdminLoggedIn={setIsAdminLoggedIn} />}
        />
        <Route
          path="/admin-chat"
          element={
            isAdminLoggedIn ? (
              <AdminChat />
            ) : (
              <Navigate to="/admin-login" replace />
            )
          }
        />
        <Route
  path="/bricks-calculator"
  element={
    <Layout>
      <BricksCalculator />
    </Layout>
  }
/>
<Route
  path="/worker-finder"
  element={
    <Layout>
      <WorkerFinder />
    </Layout>
  }
/>
<Route
  path="/blog"
  element={
    <Layout>
      <BlogList />
    </Layout>
  }
/>

<Route
  path="/blog/:blogId"
  element={
    <Layout>
      <BlogPage />
    </Layout>
  }
/>
<Route
  path="/privacy-policy"
  element={
    <Layout>
      <PrivacyPolicy />
    </Layout>
  }
/>
<Route
  path="/refund-policy"
  element={
    <Layout>
      <RefundPolicy />
    </Layout>
  }
/>
<Route
  path="/shipping-policy"
  element={
    <Layout>
      <ShippingPolicy />
    </Layout>
  }
/>
<Route
  path="/terms-conditions"
  element={
    <Layout>
      <TermsConditions />
    </Layout>
  }
/>
<Route
  path="/flyash-bricks-in-dhanbad"
  element={
    <Layout>
      <Dhanbad />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-giridih"
  element={
    <Layout>
      <Giridih />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-bokaro"
  element={
    <Layout>
      <Bokaro />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-asansol"
  element={
    <Layout>
      <Asansol />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-durgapur"
  element={
    <Layout>
      <Durgapur />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-deoghar"
  element={
    <Layout>
      <Deoghar />
    </Layout>
  }
/>

<Route
  path="/flyash-bricks-in-jamtara"
  element={
    <Layout>
      <Jamtara />
    </Layout>
  }
/>
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;
